export default __webpack_public_path__ + "static/media/ChristineJones-10.01aeea7a.jpg";